import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface CryptoWalletInterestModalProps {
  onConfirm: () => void
}

export const CryptoWalletInterestModal: BaseModalType<CryptoWalletInterestModalProps> = ({
  close,
  onConfirm,
}) => {
  const { t } = useTranslation()
  const [isConfirmed, setIsConfirmed] = useState(false)

  const handleConfirm = () => {
    if (isConfirmed) return
    setIsConfirmed(true)
    onConfirm()
    close()
  }

  return (
    <Modal>
      <Modal.Header>{t('Wallet.Crypto wallet interest title')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>{t('Wallet.Crypto wallet interest description')}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer direction='row'>
        <Modal.Footer.Secondary onClick={close}>{t('Wallet.No thanks')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={handleConfirm} disabled={isConfirmed}>
          {t('Wallet.Notify me')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
